import { createStore, applyMiddleware} from "redux";
import createSagaMiddleware from 'redux-saga';
import rootReducer from "./redux/reducers";
import { watcherSaga } from "./redux/sagas";
import { composeWithDevTools } from "redux-devtools-extension";
import { createHistory} from "@reach/router"
import { routerMiddleware } from 'react-router-redux';
// const history = createHistory();

const { logger } = require('redux-logger'); // eslint-disable-line

// middlewares.push(logger);


const sagaMiddleware = createSagaMiddleware();  
const middleWare = [sagaMiddleware,logger];

const store = createStore(rootReducer, {},
  composeWithDevTools(applyMiddleware(...middleWare))
);

sagaMiddleware.run(watcherSaga);

export default store;
